import { render } from "./More.vue?vue&type=template&id=32f8ee79&ts=true"
import script from "./More.vue?vue&type=script&lang=ts"
export * from "./More.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__